import React from 'react';
import ScrollSnapBox from "../ScrollSnapBox";
import Left_Video from "../../assets/videos/hydrogen_left.mp4";
import Right_Image from "../../assets/images/hydrogen_right.jpg";
import ReadMoreButton from '../ReadMoreButton';
import Left_Image from "../../assets/images/hydrogen_left_image.png";

const HydrogenLanding = () => {
  return (
    <ScrollSnapBox>
      {({ inView }) => (
        <div
          className="w-full flex flex-col md:flex-row px-6 sm:px-8 md:px-10 lg:px-20 my-16 sm:my-20 md:my-24 lg:my-36"
          style={{
            opacity: inView ? 1 : 0,
            transform: `translateY(${inView ? '0' : '50px'})`,
            transition: 'all 1000ms ease-out'
          }}
        >
          {/* Left side content */}
          <div className="w-full md:w-3/5 relative overflow-hidden p-6 md:p-10 mb-8 md:mb-0 md:mr-8">
            {/* Background image */}
            <video
              className="absolute top-0 left-0 w-full h-full object-cover"
              autoPlay
              loop
              muted
              playsInline
              preload="auto"
              poster={Left_Image}
            >
              <source src={Left_Video} type="video/mp4" />
              <p>Your browser does not support the video tag.</p> 
            </video>
            
            <div className="absolute inset-0 bg-sky-100/80" />
            {/* Content */}
            <div className="relative z-10 max-w-2xl">
              <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold mb-3 md:mb-6 text-gray-800">
                Green Molecules
              </h2>
              <div className="space-y-2 md:space-y-4 text-xs sm:text-sm md:text-base lg:text-lg text-gray-700">
                <p>Green molecules, made from renewable energy sources like solar and wind, are crucial for decarbonizing transportation, industry, and power generation.</p>
                <p>Here's an exploration of some key green molecules:</p>
                <ul className="list-disc pl-8">
                  <li>Hydrogen</li>
                  <li>Ammonia</li>
                  <li>Methanol</li>
                </ul>
              </div>
              <ReadMoreButton to="/hydrogen#green-molecules" />
            </div>
          </div>

          {/* Right side content */}
          <div className="w-full md:w-2/5 relative overflow-hidden p-6 md:p-10">
            {/* Background Image */}
            <img
              src={Right_Image}
              alt="Hydrogen Background"
              className="absolute inset-0 w-full h-full object-cover"
            />
            {/* Cover layer */}
            <div className="absolute top-0 left-0 w-full h-full bg-black opacity-15"></div>
            <div className="absolute inset-0" />
            {/* Content */}
            <div className="relative z-10 max-w-xl">
              <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold mb-3 md:mb-6 text-gray-800">
                Our Vision
              </h2>
              <div className="space-y-2 md:space-y-4 text-xs sm:text-sm md:text-base lg:text-lg text-gray-700">
                <p>We're Changing the Way the World Thinks About Electrolysers.</p>
                <p>To revolutionize energy systems by commercializing green molecules like hydrogen, ammonia, and methanol. We focus on:</p>
                <ul className="list-disc pl-8">
                  <li>Harnessing Renewables</li>
                  <li>Affordable Solutions</li>
                </ul>
              </div>
              <ReadMoreButton to="/organization#our-vision" />
            </div>
          </div>
        </div>
      )}
    </ScrollSnapBox>
  );
};

export default HydrogenLanding;